import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001/api';

const api = axios.create({
  baseURL: API_BASE_URL,
});

// Add auth token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Admin endpoints
export const getAdminStats = async () => {
  const response = await api.get('/admin/stats');
  return response.data;
};

export const getAllFeedbacks = async (skip = 0, limit = 100, status = null) => {
  const params = { skip, limit };
  if (status) params.status = status;
  const response = await api.get('/admin/feedbacks', { params });
  return response.data;
};

export const getAllAnalysisSessions = async (skip = 0, limit = 100) => {
  const params = { skip, limit };
  const response = await api.get('/admin/analysis-sessions', { params });
  return response.data;
};

export const getErrorLogs = async (skip = 0, limit = 100) => {
  const params = { skip, limit };
  const response = await api.get('/admin/error-logs', { params });
  return response.data;
};

export const getFeedbackDetail = async (feedbackId) => {
  const response = await api.get(`/admin/feedback/${feedbackId}`);
  return response.data;
};

export const updateFeedbackStatus = async (feedbackId, status, supportNotes = null) => {
  const response = await api.put(`/admin/feedback/${feedbackId}/status`, null, {
    params: { status, support_notes: supportNotes }
  });
  return response.data;
};

export const getUsersGeoLocations = async () => {
  const response = await api.get('/admin/geo-locations');
  return response.data;
};

// API Usage Analytics endpoints
export const getApiUsageSummary = async (days = 7) => {
  const response = await api.get('/admin/api-usage/summary', { params: { days } });
  return response.data;
};

export const getPopularFeatures = async (days = 30) => {
  const response = await api.get('/admin/api-usage/popular-features', { params: { days } });
  return response.data;
};

export const getApiUsageDetails = async (params = {}) => {
  const response = await api.get('/admin/api-usage/details', { params });
  return response.data;
};

// Race management endpoints
export const getRaceTypes = async () => {
  const response = await api.get('/races/types');
  return response.data;
};

export const getRaces = async (params = {}) => {
  const response = await api.get('/races', { params });
  return response.data;
};

export const uploadRaceGpx = async (raceId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post(`/races/admin/${raceId}/gpx`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const deleteRaceGpx = async (raceId) => {
  const response = await api.delete(`/races/admin/${raceId}/gpx`);
  return response.data;
};

export default api;
